"use client";
import { getaddtionaldata, getfbclid, getfbp } from "@/utilities/axioscall";
import { getuserid } from "@/utilities/sessionexpiry";
import Link from "next/link";
import { usePathname } from "next/navigation";
import { useEffect } from "react";

const Common = () => {
  const pathname = usePathname();

  useEffect(() => {
  if (pathname) {
    commonFunction(pathname); // Only call if pathname is not null
  }
}, [pathname]);

  async function commonFunction(pathname: string) {
    const expires = new Date(Date.now() + 60 * 24 * 60 * 60 * 1000); // 60 days
    console.info(`${pathname} ➡️ Route changed or page loaded`);

    const params = s();
    let data: Record<string, any> = { ...params };

    if (Object.keys(data).length > 0) {
      data.fbc = getfbclid();
      data.fbp = getfbp();
      data.userid = getuserid();
      data.source = pathname;
    } else {
      try {
        data = JSON.parse(await getaddtionaldata());
      } catch (e) {
        console.log(e);
      }

      data.fbc = getfbclid();
      data.fbp = getfbp();
      data.userid = getuserid();
      data.source = pathname;
      // Object.assign(data, {
      //   source: pathname,
      //   fbc: getfbclid(),
      //   fbp: getfbp(),
      //   userid: getuserid(),
      // });
    }

    if (Object.keys(data).length > 0) {
      document.cookie = `additonal_data=${encodeURIComponent(
        JSON.stringify(data)
      )};expires=${expires.toUTCString()};path=/`;
    }
  }

  function s(): Record<string, string> {
    const params = new URLSearchParams(window.location.search);
    return Object.fromEntries(params.entries());
  }

  return <></>;
};

export default Common;
